// extracted by mini-css-extract-plugin
export default {"match":"dCCxVM7FwWiN_0lKte5M","iocContent":"upCZTw8xxq11jxS_BJCU"};